import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function NewPetJourney() {
  const journeys = [{
    title: 'New Puppy Guide',
    badge: 'Puppy Starter Kit',
    badgeClass: 'badge-blue',
    description: 'Everything for their first 6 months. Get your checklist and 15% off your first puppy food purchase.',
    image: 'https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=800&q=80',
    btnClass: 'btn-primary shadow-blue-glow',
    btnText: 'Get the Puppy Guide'
  }, {
    title: 'New Kitten Guide',
    badge: 'Kitten Starter Kit',
    badgeClass: 'badge-green',
    description: 'Litter training, nutrition, and play. Get your checklist and 15% off your first kitten food purchase.',
    image: 'https://images.unsplash.com/photo-1526336024174-e58f5cdd8e13?w=800&q=80',
    btnClass: 'btn-green shadow-soft',
    btnText: 'Get the Kitten Guide'
  }, {
    title: 'First Aquarium Setup',
    badge: 'Aquarium Starter',
    badgeClass: 'badge-blue',
    description: 'Tank selection, cycling, and stocking. Our experts will guide you through every step.',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&q=80',
    btnClass: 'btn-primary shadow-blue-glow',
    btnText: 'Get the Fish Guide'
  }, {
    title: 'Garden Starter Guide',
    badge: 'Garden Essentials',
    badgeClass: 'badge-green',
    description: 'Soil prep, seasonal planting, and fertilising. Start your WA garden the right way.',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&q=80',
    btnClass: 'btn-green shadow-soft',
    btnText: 'Get the Garden Guide'
  }];
  return <section className="section-padding bg-warm-50" data-id="element-245">
      <div className="container-wide" data-id="element-246">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-247">
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-248">
            Getting Started?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-249">
            Whether it's a new pet, your first aquarium, or a garden makeover —
            we've got free starter guides and exclusive discounts to help you
            begin.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-250">
          {journeys.map((journey, index) => <div key={index} className="relative rounded-2xl overflow-hidden group h-[380px] sm:h-[420px] shadow-card hover:shadow-card-hover transition-all duration-500" data-id="element-251">
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105" style={{
            backgroundImage: `url(${journey.image})`
          }} data-id="element-252"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/95 via-gray-900/50 to-transparent" data-id="element-253"></div>

              <div className="absolute inset-0 p-6 flex flex-col justify-end" data-id="element-254">
                <span className={`${journey.badgeClass} self-start mb-3`} data-id="element-255">
                  {journey.badge}
                </span>
                <h3 className="font-heading font-bold text-2xl text-white mb-2" data-id="element-256">
                  {journey.title}
                </h3>
                <p className="text-gray-300 text-sm mb-5 leading-relaxed line-clamp-3" data-id="element-257">
                  {journey.description}
                </p>
                <button className={`${journey.btnClass} self-start flex items-center gap-2 text-sm py-2.5 px-5`} data-id="element-258">
                  {journey.btnText} <ArrowRightIcon className="w-4 h-4" data-id="element-259" />
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}